import Wrapper from "../../../layout/Wrapper";
import LifeContractServiceComponent from "../../../screens/contractControll/lifeContractPaymentDetail";

import MetaComponent from "../../../components/common/MetaComponent";

const metadata = {
	title: "payment Detail",
	description: "",
};

export default function AgentService() {
	return (
		<Wrapper>
			<MetaComponent meta={metadata} />
			<LifeContractServiceComponent />
		</Wrapper>
	);
}